import FormEditorReducer from '../../formEditor/formEditor.reducer';
import FormTemplatesReducer from '../../formTemplates/formTemplates.reducer';
import FormViewerReducer from '../../formViewer/formViewer.reducer';
import OptOutConfirmationModalReducer from '../../formViewer/optOutConfirmation/optOutConfirmation.reducer';
import ConfirmationModalReducer from '../Components/confirmation/confirmation.reducer';
import FlashMessageReducer from '../Components/flashMessage/flashMessage.reducer';
import UserSettingsReducer from '../Components/userSettings/userSettings.reducer';
import VideoReducer from '../Components/video/video.reducer';
import FormSummaryReducer from '../../formSummary/formSummary.reducer';


export default {
  formEditor: FormEditorReducer,
  formTemplates: FormTemplatesReducer,
  formViewer: FormViewerReducer,
  optOutConfirmationModal: OptOutConfirmationModalReducer,
  confirmationModal: ConfirmationModalReducer,
  message: FlashMessageReducer,
  userSettings: UserSettingsReducer,
  video: VideoReducer,
  formSummary: FormSummaryReducer
};
